import { UserRequest, portalRoles, UpdateRequest } from "../../../secure/user-management/scripts/user-management.entities";
declare var $: any;

export class TrialAccessPage {
    requestUpdateBtn: JQuery<HTMLElement>;
    submitSpinner: JQuery<HTMLElement>;
    errorMessageAll: JQuery<HTMLElement>;
    originalValues: any = {};
    roles: portalRoles[];
    user: UserRequest;
    constructor(user: any, rolesJson: any) {
        this.roles = this.applyDisplayNames(rolesJson);
        this.user = user;
        $(() => {
            this.requestUpdateBtn = $("#request-update-btn");
            this.submitSpinner = $("#submit-spinner");
            this.errorMessageAll = $("#all-error-message");
            this.populateRoleBoxes(this.user, this.roles);
            this.initalizeListeners();
        })
    }
 
  
    private populateRoleBoxes(user: any, allRoles: any,) {
        const { currentRoles, availableRoles } = this.splitRoles(user, allRoles);

        $("#current-container").html(this.renderRoles(currentRoles));
        $("#request-container").html(this.renderRoles(availableRoles));
    }

    private splitRoles(user: UserRequest, allRoles: portalRoles[]) {
        const currentRoles = allRoles.filter(role =>
            user.Roles.includes(role.Name)
        );

        const availableRoles = allRoles.filter(role =>
            !user.Roles.includes(role.Name)
        );

        return { currentRoles, availableRoles };
    }

    private readonly roleDisplayNames: Record<string, string> = {              
        "Trials1and2": "Core Protocol Working Group",
        "LDNTrial": "Trial - LDN",
        "VUMCBariTrial": "Trial - VUMC Bari",
        "Trial-GLP1": "Trial - GLP-1",
        "Trial-SGB": "Trial - SGB",
        "RVLC-Safety-Monitoring": "RVLC Safety Monitoring",
        "LDN-Bioequivalence": "LDN Bioequivalence",
        "Vendor-Alcami": "Vendor - Alcami",
        "Vendor-ICON": "Vendor - ICON",
    };

    private applyDisplayNames(roles: portalRoles[]): portalRoles[] {
        return roles.map(role => ({
            ...role,
            DisplayName: this.roleDisplayNames[role.Name] ?? role.Name
        }));
    }

    private renderRoles(roles: portalRoles[]): string {

        let html = ` `;
        html += `
            <div class="col-md-6 col-12">
                <div class="form-group">
                   <div class="row">
        `;
        roles.forEach((role => {
            html += `
                <div class="col-md-6 col-12">
                    <div class="form-check">
                        <input type="checkbox" name="${role.Name}" id="Input_${role.Name}" value="${role.Name}" class="form-check-input"/>
                        <label for="Input_${role.Name}" class="form-check-label">${role.DisplayName}</label>
                    </div>
                </div>
            `;
        }));

        html += `</div></div></div>`;
        
        return html;
    }   

    initalizeListeners() {
        this.requestUpdateBtn.on("click", async (e) => {
            e.preventDefault();         
            const accountRequest = this.createRequest();
            if (!accountRequest) {
                this.errorMessageAll = $("#all-error-message");
                this.errorMessageAll
                    .text("No changes were made. Please check at least one box in either group.")
                    .removeClass("d-none");
                return;
            }
            this.requestUpdateBtn.addClass("d-none");
            this.submitSpinner.removeClass("d-none");
            $("#trial-access-container").addClass("ui-blocked");
            try {
                const result = await this.requestAccessUpdate(accountRequest);
                await this.showStatusMessage(result.message);
            }
            finally {
                $("#trial-access-container").removeClass("ui-blocked");
                this.requestUpdateBtn.removeClass("d-none");
                this.submitSpinner.addClass("d-none");
            } 
        })
    }

    async showStatusMessage(message: string) {
        const html = await $.ajax({
            url: `/auth/pages/profile/update_trial_access?handler=StatusMessage`,
            method: "GET",
            data: { message }
        });

        $("#status-message-container").html(html);
    }

    private createRequest(): UpdateRequest | null {
        const { rolesToRemove, rolesToAdd } = this.verifyRolesSelected();
        const requestJson: any = {};

        if (rolesToRemove.length > 0) {
            requestJson.RolesToRemove = rolesToRemove;
        }

        if (rolesToAdd.length > 0) {
            requestJson.RolesToAdd = rolesToAdd;
        }

        if (rolesToAdd.length == 0 && rolesToRemove.length == 0) {
            return null
        }

        let request = new UpdateRequest(); 
            request.Email = this.user.Email,
            request.FirstName = this.user.FirstName,
            request.LastName = this.user.LastName,
            // 1 is pending 2 is approved 3 is denies
            request.StatusId = 1,
            // 1 is for contatct info 2 is for trial access
            request.TypeId = 2,
            request.RequestJson = Object.keys(requestJson).length > 0 ? JSON.stringify(requestJson) : null
        return request;
    }

    private verifyRolesSelected() {
        const rolesToRemove: string[] = [];
        const rolesToAdd: string[] = [];

        const allCheckboxes = $(".form-check-input");

        $("#current-container .form-check-input:checked").each((_, el) => {
            rolesToRemove.push($(el).val() as string);
        });

        $("#request-container .form-check-input:checked").each((_, el) => {
            rolesToAdd.push($(el).val() as string);
        });

        return { rolesToRemove, rolesToAdd };
    }

    async requestAccessUpdate(data: any): Promise<any> {
        try {
            const result = await $.ajax({
                url: `/auth/pages/profile/update_trial_access?handler=RequestAccessUpdate`,
                method: "POST", 
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
                data: {
                    data: JSON.stringify(data),
                }
            });   
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

}